module.exports = __webpack_public_path__ + "img/web.2f1b8d1e.svg";